export default () => {
  const organizations = document.querySelectorAll('.organization');
  const { length } = organizations;
  const { children: lastOrgChildren } = organizations[length - 1];
  const roleParent = lastOrgChildren[1];
  return roleParent;
};
